import LegalLayout, { LegalSection } from "@/components/LegalLayout";
import { SITE } from "@/config/siteConfig";

export default function PolitiqueConfidentialite() {
  return (
    <LegalLayout title="Politique de confidentialité" updatedAt="août 2026" testId="privacy-page">
      <p className="rounded-2xl border border-jeem-yellow/60 bg-jeem-yellow/10 p-4 text-sm">
        Ce document est un modèle inspiré des pratiques courantes des entreprises de télécommunications au Québec (notamment la Loi 25 sur la protection des renseignements personnels). Faites-le valider par un professionnel avant publication officielle.
      </p>

      <LegalSection title="1. Responsable de la protection des renseignements personnels">
        <p>
          {SITE.companyName} désigne un responsable de la protection des renseignements personnels, conformément à la Loi modernisant des dispositions législatives en matière de protection des renseignements personnels (Loi 25, Québec). Pour toute question relative à cette politique ou à vos renseignements personnels, écrivez à <a className="font-semibold text-black underline decoration-jeem-yellow decoration-2 underline-offset-2" href={`mailto:${SITE.email}`}>{SITE.email}</a> ou composez le {SITE.phone}.
        </p>
      </LegalSection>

      <LegalSection title="2. Renseignements collectés">
        <p>Nous collectons uniquement les renseignements nécessaires pour répondre à vos demandes et vous accompagner dans le choix d'un service :</p>
        <ul className="mt-3 list-disc space-y-1.5 pl-6">
          <li>Nom, numéro de téléphone et adresse courriel (formulaire de contact et échanges WhatsApp) ;</li>
          <li>L'offre ou le service qui vous intéresse ;</li>
          <li>Le contenu des messages que vous nous envoyez ;</li>
          <li>Des données de navigation anonymisées (pages visitées, appareil, provenance — par exemple une publicité Facebook ou Instagram).</li>
        </ul>
      </LegalSection>

      <LegalSection title="3. Utilisation des renseignements">
        <p>Vos renseignements servent exclusivement à :</p>
        <ul className="mt-3 list-disc space-y-1.5 pl-6">
          <li>Répondre à vos demandes et vous conseiller sur nos offres ;</li>
          <li>Assurer le suivi de votre inscription ou de votre activation ;</li>
          <li>Améliorer notre site et mesurer l'efficacité de nos publicités ;</li>
          <li>Respecter nos obligations légales et réglementaires.</li>
        </ul>
        <p className="mt-3">Nous ne vendons jamais vos renseignements personnels à des tiers.</p>
      </LegalSection>

      <LegalSection title="4. Témoins (cookies) et outils de mesure">
        <p>
          Notre site peut utiliser des témoins et des outils de mesure publicitaire (Meta Pixel, Google Analytics, Google Tag Manager) pour comprendre l'origine de nos visiteurs et améliorer nos campagnes. Vous pouvez désactiver les témoins dans les paramètres de votre navigateur; certaines fonctionnalités pourraient alors être limitées.
        </p>
      </LegalSection>

      <LegalSection title="5. Conservation et sécurité">
        <p>
          Vos renseignements sont conservés uniquement le temps nécessaire aux fins décrites dans cette politique, puis détruits ou anonymisés de façon sécuritaire. Nous appliquons des mesures de protection administratives, techniques et physiques proportionnées à la sensibilité des renseignements.
        </p>
      </LegalSection>

      <LegalSection title="6. Vos droits">
        <p>Conformément à la Loi 25, vous avez le droit de :</p>
        <ul className="mt-3 list-disc space-y-1.5 pl-6">
          <li>Accéder aux renseignements personnels que nous détenons à votre sujet ;</li>
          <li>Demander leur rectification s'ils sont inexacts ou incomplets ;</li>
          <li>Retirer votre consentement à leur utilisation ;</li>
          <li>Porter plainte à la Commission d'accès à l'information du Québec si vous estimez que vos droits ne sont pas respectés.</li>
        </ul>
      </LegalSection>

      <LegalSection title="7. Modifications">
        <p>
          Cette politique peut être mise à jour pour refléter l'évolution de nos pratiques ou de la loi. La version en vigueur est celle publiée sur cette page.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
